<div class="preview-claim">
  <section class="preview-card">
    <h3 class="preview-card__title">Solicitud</h3>
    <dl class="preview-kv">
      <div class="preview-kv__row">
        <dt>Tipo</dt>
        <dd>{{ claimTypeLabel }}</dd>
      </div>
      <div class="preview-kv__row">
        <dt>Vehículo</dt>
        <dd>{{ vehicleLabel }}</dd>
      </div>
      <div class="preview-kv__row">
        <dt>Folio</dt>
        <dd>{{ folio }}</dd>
      </div>
      @if (createdAtLabel) {
        <div class="preview-kv__row">
          <dt>Ingreso</dt>
          <dd>{{ createdAtLabel }}</dd>
        </div>
      }
      <div class="preview-kv__row">
        <dt>Estado</dt>
        <dd>{{ statusLabel }}</dd>
      </div>
    </dl>
  </section>

  <section class="preview-card">
    <h3 class="preview-card__title">Socio</h3>
    <dl class="preview-kv">
      @if (partyName) {
        <div class="preview-kv__row">
          <dt>Nombre</dt>
          <dd>{{ partyName }}</dd>
        </div>
      }
      @if (party()?.rut) {
        <div class="preview-kv__row">
          <dt>RUT</dt>
          <dd>{{ party()?.rut }}</dd>
        </div>
      }
      @if (entityLabel) {
        <div class="preview-kv__row">
          <dt>Entidad</dt>
          <dd>{{ entityLabel }}</dd>
        </div>
      }
      @if (groupLabel && groupLabel !== 'Sin Grupo') {
        <div class="preview-kv__row">
          <dt>Grupo</dt>
          <dd>{{ groupLabel }}</dd>
        </div>
      }
      @if (party()?.mail) {
        <div class="preview-kv__row">
          <dt>Correo</dt>
          <dd>{{ party()?.mail }}</dd>
        </div>
      }
      @if (party()?.mobileNumber) {
        <div class="preview-kv__row">
          <dt>Teléfono</dt>
          <dd>{{ party()?.mobileNumber }}</dd>
        </div>
      }
    </dl>
  </section>

  @if (requesterLabel || createdAtLabel) {
    <section class="preview-card">
      <h3 class="preview-card__title">Solicitado por</h3>
      <dl class="preview-kv">
        @if (requesterLabel) {
          <div class="preview-kv__row">
            <dt>Origen</dt>
            <dd>{{ requesterLabel }}</dd>
          </div>
        }
        @if (createdAtLabel) {
          <div class="preview-kv__row">
            <dt>Fecha</dt>
            <dd>{{ createdAtLabel }}</dd>
          </div>
        }
      </dl>
    </section>
  }

  <section class="preview-card preview-card--flush">
    <app-claim-summary
      [laborCost]="laborCost"
      [partsCost]="partsCost"
      [totalCost]="totalCost"
      [totalDeductible]="totalDeductible"
      [netReimbursement]="netReimbursement"
      [isTotalLoss]="isTotalLoss"
      [vehicleValue]="vehicleValue"
      [retentionPct]="retentionPct"
      [isNegligence]="isNegligence">
    </app-claim-summary>
  </section>

  @if (showActions()) {
    <div class="preview-claim__actions">
      <button type="button" class="btn btn-primary w-100 fw-semibold" (click)="approve.emit()" [disabled]="isSubmitting()">
        <i class="fas fa-check-circle me-2" [class.fa-spin]="isSubmitting()"></i> Dar visto bueno
      </button>
      <button type="button" class="btn btn-outline-secondary w-100" (click)="reject.emit()" [disabled]="isSubmitting()">
        <i class="fas fa-times-circle me-1"></i> Rechazar siniestro
      </button>
    </div>
  }
</div>
